import { render, staticRenderFns } from "./ProductBrowserSupport.vue?vue&type=template&id=e4f6d3be"
import script from "./ProductBrowserSupport.vue?vue&type=script&lang=js"
export * from "./ProductBrowserSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports